import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatterDocumentType } from '@models/matter-file';
import { DocumentProcessorService } from '@services/document-ai/document-processor.service';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-ai-document-processing-loading',
	templateUrl: './ai-document-processing-loading.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class AiDocumentProcessingLoadingComponent {
	public isOCRProcessing$: Observable<boolean>;
	public _matterDocumentType: MatterDocumentType;

	@Input() set matterDocumentType(matterDocumentType: MatterDocumentType) {
		this._matterDocumentType = matterDocumentType;
		this.isOCRProcessing$ =
			this.documentProcessorService.isLoading$(matterDocumentType);
	}

	constructor(private documentProcessorService: DocumentProcessorService) {}
}
